import request from "project-config/services/request/request";
import {
  OrderPaymentTypeCode,
  PaymentPurposeCode,
  PaymentTypeCode,
  QRCODE_QUERY_MAP,
  rechargeChannelsCode,
} from "project-config/constants";
import React, { useEffect, useState } from "react";
import { MemberLevelProps, VipRechargeInfo, vipRules } from "../../constants";
import {
  CappedCouponIcon,
  DiscountCouponIcon,
  FreeCouponIcon,
  RenderSampleIcon,
} from "../../icons";
import VipTopIcon from "../../images/vip-icon.png";
import NormalTopIcon from "../../images/normal-icon.png";
import VipPrivilegeBg from "../../images/vip-privilege-bg.png";
import {
  LeftContent,
  MemberShipFeatureGroupWrapper,
  MembershipCardHeader,
  MembershipContent,
  MembershipContentWrapper,
  MembershipFeature,
  RightContent,
  MembershipLevelCard,
  MembershipLevelCardGroup,
  MembershipViewWrapper,
  MonthWrapper,
  PricePerMonthWrapper,
  PriceWrapper,
  TopIcon,
  VipTitle,
  OriginalPrice,
} from "./atom";
import { handlePaycode } from "@/utils";
import RuleModal from "../rule-modal";
import { BindActivityInfo } from "@/components/top-up/types";
import { rulesContentList } from "@/components/top-up/help/activityUtil";
import { Space } from "task-eva-ui";
import { PaymentWay } from "../payment-way";
import { payWithAli } from "@/components/top-up/help/payWithAli";
import { ExtraWelfareTipType, RechargeTips } from "../../help/tips";
import { useClientTopUpStore } from "../../store";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { useGlobalStore } from "@/store/GlobalStore";
import { Checkbox } from "@renderbus/ui";
import { CommonCornerMark } from "../../atom";
const MemberShipFeatureGroup = [
  {
    key: "discount",
    icon: <DiscountCouponIcon />,
    title: "会员专享价",
    tip: "享渲图7.5折,低至0.03元/分钟",
  },
  {
    key: "free",
    icon: <FreeCouponIcon />,
    title: "每月免单券",
    tip: "享免渲染费4次",
  },
  {
    key: "capped",
    icon: <CappedCouponIcon />,
    title: "20元封顶",
    tip: "享封顶价8折优惠",
  },
  {
    key: "render-sample",
    icon: <RenderSampleIcon />,
    title: "免费渲小样",
    tip: "享无限次免费渲染小样",
  },
];
// activityType === 0 && vipAmount!==0 效果图会员活动

const Membership: React.FC<{
  memberActivityList?: BindActivityInfo[];
}> = ({ memberActivityList }) => {
  const memberActivity = memberActivityList?.[0];
  const [memberLevelData, setMemberLevelData] = useState<MemberLevelProps[]>();
  const [activeCard, setActiveCard] = useState<MemberLevelProps>();
  const [ruleOpen, setRuleOpen] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [paying, setPaying] = useState<boolean>(false);
  const { rechargeAmount } = useClientTopUpStore();
  const { userProperty } = useUserPropertyStore();
  const { userInfo, currencySymbol } = useGlobalStore();
  const [extraTip, setExtraTip] = useState<ExtraWelfareTipType[]>();

  const getDefaultQrCodeLink = () =>
    `&${QRCODE_QUERY_MAP.orderType}=3&${QRCODE_QUERY_MAP.type}=${
      activeCard?.type
    }&${QRCODE_QUERY_MAP.mount}=${1}&${QRCODE_QUERY_MAP.rechargeGoal}=${
      PaymentPurposeCode.OrdinaryRecharge
    }`;
  const getActivityQrCodeLink = () => {
    let paramsStr = `&${QRCODE_QUERY_MAP.orderType}=${
      OrderPaymentTypeCode.MemberOrder
    }
      &${QRCODE_QUERY_MAP.type}=${activeCard?.type}&${
      QRCODE_QUERY_MAP.mount
    }=1&${QRCODE_QUERY_MAP.rechargeGoal}=${
      !activeCard?.vipPresentMonth
        ? PaymentPurposeCode.OrdinaryRecharge
        : PaymentPurposeCode.ActivityRecharge
    }`;
    return paramsStr;
  };
  // const getActivityQrCodeLink = () => {
  //   let paramsStr = `&${QRCODE_QUERY_MAP.orderType}=${
  //     !activeCard?.vipPresentMonth
  //       ? activeCard?.type
  //       : OrderPaymentTypeCode.MemberOrder
  //   }&${QRCODE_QUERY_MAP.type}=${"undefined"}&${QRCODE_QUERY_MAP.mount}=1&${
  //     QRCODE_QUERY_MAP.rechargeGoal
  //   }=${
  //     !activeCard?.vipPresentMonth
  //       ? PaymentPurposeCode.OrdinaryRecharge
  //       : PaymentPurposeCode.ActivityRecharge
  //   }`;
  //   return paramsStr;
  // };
  const onClickCantScanCode = async () => {
    setPaying(true);
    const params = memberActivity
      ? {
          payMethod: PaymentTypeCode.Alipay,
          mount: 1,
          type: activeCard?.type ?? 1,
          rechargeGoal: !activeCard?.vipPresentMonth
            ? PaymentPurposeCode.OrdinaryRecharge
            : PaymentPurposeCode.ActivityRecharge,
          rechargeChannels: rechargeChannelsCode.Client,
        }
      : {
          payMethod: PaymentTypeCode.Alipay,
          mount: 1,
          type: activeCard?.type ?? 1,
          rechargeGoal: PaymentPurposeCode.OrdinaryRecharge,
          rechargeChannels: rechargeChannelsCode.Client,
        };

    const apiName = "/api/rendering/pay/recharge/addMemberRecharge";
    const { code, data } = await request.post(apiName, params);
    if (code !== 200) {
      setPaying(false);
      handlePaycode(code);
      return;
    }
    payWithAli(data.params, () => "todo modal");
    setPaying(false);
  };

  useEffect(() => {
    if (!memberActivity) {
      setMemberLevelData(VipRechargeInfo);
    } else {
      const activityDetail: {
        vipMonth?: number;
        vipPresentMonth?: number;
        iconWord?: string;
      }[] = memberActivity.activityDetail.map((activity) => {
        return {
          vipMonth: activity.vipAmount,
          vipPresentMonth: activity.vipPresentAmount,
          iconWord: activity.iconWord,
        };
      });
      const activityList = VipRechargeInfo.map((info) => {
        const activityMember = activityDetail.filter(
          (item) => info.vipMonth === item.vipMonth
        );
        return activityMember.length === 0
          ? info
          : {
              ...info,
              ...activityMember[0],
            };
      });
      setMemberLevelData(activityList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberActivity]);
  useEffect(() => {
    setActiveCard(memberLevelData?.[0]);
  }, [memberLevelData]);

  useEffect(() => {
    if (memberActivity) {
      const rechargeTips = new RechargeTips({
        amount: Number(rechargeAmount),
        userProperty,
        currencySymbol,
        activityInfo: memberActivity,
        activityDetailItem: activeCard,
      });
      rechargeTips.init();
      setExtraTip(rechargeTips.extraWelfareTip);
    }
  }, [
    rechargeAmount,
    userProperty,
    currencySymbol,
    memberActivity,
    activeCard,
  ]);
  return (
    <MembershipViewWrapper>
      <TopIcon>
        <img src={userInfo?.pictureLever ? VipTopIcon : NormalTopIcon} alt="" />
      </TopIcon>
      <MembershipContentWrapper>
        <LeftContent>
          <MembershipCardHeader>
            <img src={VipPrivilegeBg} alt="" className="privilege-bg" />
            <MemberShipFeatureGroupWrapper>
              {MemberShipFeatureGroup.map((item) => (
                <MembershipFeature key={item.key}>
                  <Space gap="4" align="center">
                    {item.icon}
                    <div>
                      <p className="title">{item.title}</p>
                      <p className="tip">{item.tip}</p>
                    </div>
                  </Space>
                </MembershipFeature>
              ))}
            </MemberShipFeatureGroupWrapper>
          </MembershipCardHeader>
          <MembershipContent>
            <Space justify="space-between" width="100%">
              <VipTitle>
                {memberActivity ? memberActivity.activityName : "会员订阅"}
              </VipTitle>
              <RuleModal
                type="vip"
                ruleList={
                  memberActivity
                    ? rulesContentList(memberActivity, true)
                    : vipRules
                }
                open={ruleOpen}
                setRuleOpen={(val) => {
                  setRuleOpen(val);
                }}
              />
            </Space>
            <MembershipLevelCardGroup>
              {memberLevelData?.map((item) => (
                <MembershipLevelCard
                  key={item.type}
                  className={activeCard?.type === item.type ? "active" : ""}
                  onClick={() => setActiveCard(item)}
                >
                  {item.iconWord && item.iconWord !== "" && (
                    <CommonCornerMark>{item.iconWord}</CommonCornerMark>
                  )}
                  <MonthWrapper>{item.vipMonth}个月</MonthWrapper>
                  <PriceWrapper>
                    <span className="symbol">¥</span>
                    <span>{item.price}</span>
                  </PriceWrapper>
                  <OriginalPrice>¥{item.originalPrice}</OriginalPrice>
                  {item.vipPresentMonth ? (
                    <PricePerMonthWrapper
                      className={activeCard?.type === item.type ? "active" : ""}
                    >
                      <span>赠送 会员{item.vipPresentMonth}个月</span>
                    </PricePerMonthWrapper>
                  ) : (
                    item.vipMonth !== 1 && (
                      <PricePerMonthWrapper
                        className={
                          activeCard?.type === item.type ? "active" : ""
                        }
                      >
                        立省 {Number(item.originalPrice - item.price)}元
                      </PricePerMonthWrapper>
                    )
                  )}
                </MembershipLevelCard>
              ))}
            </MembershipLevelCardGroup>
          </MembershipContent>
        </LeftContent>
        <RightContent>
          <PaymentWay
            disabledProtocol={!checked}
            account={activeCard?.price ?? 0}
            activityDetailItem={activeCard}
            qrcodeLink={
              memberActivity ? getActivityQrCodeLink() : getDefaultQrCodeLink()
            }
            onClickCantScanCode={onClickCantScanCode}
            paying={paying}
            extraTip={extraTip}
            isVipRecharge={true}
            extra={
              <div className="pay-item">
                <Checkbox
                  value={checked}
                  onChange={() => setChecked(!checked)}
                  className="picture-vip-protocols"
                />
                <div>
                  <span>我已阅读并同意</span>
                  <a
                    href={
                      "https://www.renderbus.com/support-new/xrxz/fwtkyts/xgthyxy/"
                    }
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    《效果图会员协议》
                  </a>
                </div>
              </div>
            }
          />
        </RightContent>
      </MembershipContentWrapper>
    </MembershipViewWrapper>
  );
};

const MembershipView: React.FC<{
  memberActivityList?: BindActivityInfo[];
}> = ({ memberActivityList }) => {
  return <Membership memberActivityList={memberActivityList} />;
};
export default MembershipView;
